var map = {
	"./ar": 1653,
	"./ar.js": 1653,
	"./de": 5840,
	"./de.js": 5840,
	"./en-US": 5109,
	"./en-US.js": 5109,
	"./es": 1088,
	"./es.js": 1088,
	"./fr": 9382,
	"./fr.js": 9382,
	"./hi": 577,
	"./hi.js": 577,
	"./it": 1737,
	"./it.js": 1737,
	"./pt": 5717,
	"./pt.js": 5717,
	"./ru": 9611,
	"./ru.js": 9611,
	"./zh-CN": 5577,
	"./zh-CN.js": 5577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;